module.exports = __webpack_public_path__ + "static/media/cp5in.4c8f9fa2.png";